import { IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import type { UpsellFeatureProps } from './UpsellFeature';
import { UpsellFeatureContainer } from './UpsellFeatureContainer';

import styles from './UpsellModal.module.css';
export type UpsellFeatureModalProps = Omit<UpsellFeatureProps, 'canManagePlans'> & {
  isOpen: boolean;
  onCancel(): void;
};

export function UpsellModal({
  customCta,
  description,
  featureBullets,
  featureKind,
  isEnterpriseOnlyFeature,
  learnMoreUrl,
  isOpen,
  onCancel,
  title,
  featureImage,
  componentForAnalyticTracking,
}: UpsellFeatureModalProps) {
  return (
    <ModalOverlay isOpen={isOpen}>
      <Modal>
        <div slot="header" className={styles.header}>
          <IconButton icon="cancel" variant="minimal" onPress={onCancel} aria-label="Close" />
        </div>
        <UpsellFeatureContainer
          customCta={customCta}
          description={description}
          featureBullets={featureBullets}
          featureKind={featureKind}
          featureImage={featureImage}
          isEnterpriseOnlyFeature={isEnterpriseOnlyFeature}
          isModal
          learnMoreUrl={learnMoreUrl}
          componentForAnalyticTracking={componentForAnalyticTracking}
          title={title}
        />
      </Modal>
    </ModalOverlay>
  );
}
